import React, { FC, useState } from 'react'

import styled from 'styled-components'

import { CouponBonusTooltip } from 'src/Components/CouponBonusTooltip'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'

import { ScheduleSummaryProps } from '..'

import { ScheduleSummaryPromocodePopup } from './ScheduleSummaryPromocodePopup'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`
const StyledPrimaryDottedButton = styled(PrimaryDottedButton)`
  padding-left: 0;
`

type Props = Pick<ScheduleSummaryProps, 'onApplyPromocode'>

const BONUS_COUPON_SUCCESS_MESSAGE =
  "Coupon applied! You'll get a bonus credited to your balance once you've paid for this campaign."

export const ScheduleSummaryPromocode: FC<Props> = ({ onApplyPromocode }) => {
  const [open, setOpen] = useState(false)
  const [showBonusSuccess, setShowBonusSuccess] = useState(false)

  const handleClose = (): void => {
    setOpen(false)
  }

  const handleOpenPopup = (): void => {
    setShowBonusSuccess(false)
    setOpen(true)
  }

  return (
    <Container>
      <ScheduleSummaryPromocodePopup
        open={open}
        onCancel={() => setOpen(false)}
        onClose={handleClose}
        onApplyPromocode={onApplyPromocode}
        onBonusCouponApplied={() => setShowBonusSuccess(true)}
      />
      {showBonusSuccess ? (
        <CouponBonusTooltip>{BONUS_COUPON_SUCCESS_MESSAGE}</CouponBonusTooltip>
      ) : (
        <StyledPrimaryDottedButton onClick={handleOpenPopup}>
          Have a promo code?
        </StyledPrimaryDottedButton>
      )}
    </Container>
  )
}
